<!-- Header -->
<nav class="navbar company navbar-expand-xl">
  <div class="container px-auto d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <a href="https://www.travelgate.com/" class="navbar-brand">
        <img src="assets/img/logos/logo_travelgate_white.svg" alt="Logo Travelgate" />
      </a>
      <div class="stamp">
        <img src="assets/img/pages/onboarding/onboarding_stamp_white.svg" alt="Stamp onboarding" />
        <p class="stamp__pill">Company</p>
      </div>
    </div>
    <div>
      <ul class="navbar-nav align-items-center flex-row">
        <li class="nav-item txt">
          Company: {{ companyName }}
          @if (isBuyer || isSeller) {
            <span>
              @if (isBuyer) {
                <xen-badge type="label" [status]="'buyer'" theme="light" [label]="'Buyer'"></xen-badge>
              }
              @if (isSeller) {
                <xen-badge type="label" [status]="'seller'" theme="light" [label]="'Seller'"></xen-badge>
              }
            </span>
          }
        </li>
        <li class="nav-item ms-lg-2 ms-xl-0">
          <a
            class="nav-link dropdown-toggle logout-menu-dropdown"
            data-toggle="dropdown"
            data-bs-toggle="dropdown"
            id="dropdown--profile"
            role="button"
            aria-expanded="false"
            #buttonMenu
          >
            <img alt="Avatar" src="{{ userImg }}" />
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end position-absolute dropdown-logout"
            aria-labelledby="dropdown--profile"
            (click)="$event.stopPropagation()"
          >
            <div class="nav-link__nav-profile-info position-relative">
              <div class="nav-profile-info__profile-image d-flex align-self-start mb-1">
                <img src="{{ userImg }}" alt="Avatar" />
                <div class="ms-2 mt-0">
                  <p class="nav-profile-info__profile-name mb-0">
                    {{ userName }}
                  </p>
                  <p class="nav-profile-info__profile-email mb-1">
                    {{ loggedUser?.email }}
                  </p>
                  <xen-badge
                    [type]="'label'"
                    [status]="statusUserRoleBackgroundBadge"
                    [theme]="'dark'"
                    label="{{ loggedUser?.role?.charAt(0).toUpperCase() + loggedUser?.role?.slice(1).toLowerCase() }}"
                    [amount]="5"
                    [icon]="'far fa-cookie-bite'"
                  ></xen-badge>
                </div>
              </div>
              <!-- Header select organization -->
              <tgx-selected-organization />
              <!-- logout -->
              <li class="settings">
                <div class="settings">
                  <xen-link
                    size="body"
                    weight="regular"
                    label="Sign out"
                    [icon]="true"
                    icon_snippet="fa-regular fa-right-from-bracket"
                    icon_placement="left"
                    theme="dark"
                    target="_self"
                    [underlined]="false"
                    [block]="true"
                    (click)="signOut()"
                  ></xen-link>
                </div>
              </li>
            </div>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
